import React, { Component } from 'react';

// Menu item titles are clipped to a fixed-height row. When the text is too
// long to fit, this scrolls it horizontally like a marquee/letreiro instead
// of letting it wrap and get cut off. Short titles that already fit render
// as plain text, untouched.
class MarqueeText extends Component {
  state = { overflowing: false };

  containerRef = React.createRef();

  componentDidMount() {
    this.checkOverflow();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      this.checkOverflow();
    }
  }

  checkOverflow = () => {
    const el = this.containerRef.current;
    if (el && el.scrollWidth > el.clientWidth + 1) {
      this.setState({ overflowing: true });
    }
  };

  render() {
    const { text } = this.props;
    const { overflowing } = this.state;

    if (!overflowing) {
      return (
        <span className="marquee" ref={this.containerRef}>
          {text}
        </span>
      );
    }

    return (
      <span className="marquee" ref={this.containerRef}>
        <span className="marquee-track">
          <span className="marquee-copy">{text}</span>
          <span className="marquee-copy">{text}</span>
        </span>
      </span>
    );
  }
}

export default MarqueeText;
